<h2>storytime.</h2>
<p class="about">Eines der besten Beispiele für Selbstüberschätzung und Größenwahnsinn. Nachdem die Homepage vom Volkstheater so guten Anklang bekamm wurde der Ruf
    eines eignen Ticketsystems im Vorstand immer lauter. Zu der Zeit hatte ich leider noch das Problem zu allem Ja und Amen zu sagen und habe gemeint "Klar können wir
    unser eigenen Ticketsystem bauen".
    <br>
    <br>
    Nach ein bisschen Planung und Recherche habe ich ein Plugin gefunden das mir das ganze recht leicht umsetzen lies. Der Aufbau war gar nicht so das Problem, es ist der
    Kundenservice der den Flaschenhals des Projektes bildet. Bei einer Veranstaltung von mehr als 400 Gästen kommen schon mal die ein oder anderen Probleme vor und wenn man das dann
    alleine für ein paar 100 Leute pro Theaterprojekt macht büßt man ganz schön viel Privatleben ein.  
</p>
<h2>plottwist.</h2>
<p class="about">Auch wenn das anlegen der Veranstaltungen und der Kundenservice ganz schön an den Nerven nagen, macht es umso mehr Spaß am Tag der Veranstaltungen dann die Leute zu sehen, die 
    Tickets über "dein" System gekauft haben und jetzt an der Kasse diese entwerten. Die Krönung des Ganzen ist dann auch noch wenn jeder Zuschauer ohne Probleme seinen Platz findet und die 
    Einweiser nicht viel Arbeit haben.
    <br>
    <br>
    Das ist quasi mein größer Lohn nach den ganzen vorherigen Strapatzen. 
</p>